/**
 * `/analytics/all` route. Renders the same analytics dashboard layout as
 * the per-market `/analytics/current` page, but with `marketId={null}`
 * so the data-api aggregates the Running / Directional / Window-analytics
 * / Timing & Dip stats across every market in the catalogue.
 *
 * The shared body lives in `AnalyticsDashboard.tsx`; this file is just a
 * thin route component that picks the title and omits the market filter.
 */
import { AnalyticsDashboardBody } from "./AnalyticsDashboard";

export function AnalyticsAllMarketsPage() {
  return <AnalyticsDashboardBody marketId={null} titleSuffix="All Markets" />;
}
